export const Utils = {
  getBaseApiUrl() {
    const stage = process.env.REACT_APP_STAGE;
    let baseUrl = "https://nrgcal.limarktech.com"
    switch (stage) {
      case 'dev': 
        baseUrl = "https://nrgcal.limarktech.com"
        break;
      default:
        baseUrl = "http://localhost:8080"
    }
    return `${baseUrl}/api/v1`;
  },

  formatCurrency(x) {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
  }
};